// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/training_session_icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.training-options-filter {
    display: flex;
    margin-top: 0 !important;
    margin: 20px 12px;
    padding-bottom: 7px;
    justify-content: space-around;

}

.hr_info_session {
    display: flex;
    flex-direction: column;
    font-size: 12px;
}

.sessionselectedgrp {
    color: #343339;
    font-size: 15px;
    font-weight: 600;
    margin: 15px 10px;
}

.session_edit {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.session_edit p {
    margin: 0;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 10%, #fff);
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 22%, #fff);
    color: var(--brand-primary, #0877BC);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.session_edit p:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent);
}

.deactive_btn {
    background-color: #d31212;
    border-radius: 8px;
    margin: 6px;
    padding: 3px 16px;
    color: #fff;
    font-size: 13px;
    border: none;
    outline: none;
}

.session-state {
    font-size: 11px;
    border-radius: 5px;
    background-color: var(--brand-primary, #0877BC);
    color: #fff;
    padding: 3px 8px;
    font-weight: 600;
}

/* Session state badges with better contrast for Today's Training Sessions */
.today-sessions .session-state {
    background-color: #0877BC !important; /* Default blue background */
    color: #fff !important; /* White text for contrast */
    font-weight: 600;
}

/* State-specific colors for session-state badge in Today's Training Sessions */
.today-sessions .sessions-list > li.scheduled .session-state,
.today-sessions .sessions-list ul li.scheduled .session-state {
    background-color: #6c757d !important; /* Gray background to match border */
    color: #fff !important; /* White text for contrast */
}

.today-sessions .sessions-list > li.running .session-state,
.today-sessions .sessions-list ul li.running .session-state {
    background-color: #28a745 !important; /* Green background to match border */
    color: #fff !important; /* White text for contrast */
}

.today-sessions .sessions-list > li.paused .session-state,
.today-sessions .sessions-list ul li.paused .session-state {
    background-color: #ffc107 !important; /* Yellow background to match border */
    color: #000 !important; /* Black text for better contrast on yellow */
}

.today-sessions .sessions-list > li.finalized .session-state,
.today-sessions .sessions-list ul li.finalized .session-state {
    background-color: #dc3545 !important; /* Red background to match border */
    color: #fff !important; /* White text for contrast */
}

.session-start {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.filter {
    background: #fff;
    border: none;
    border-radius: 16px;
    min-width: 130px;
    padding: 5px 7px;
    color: #404B52;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    white-space: nowrap;
    cursor: pointer;

}

.selected-filter {
    background: var(--Primary-Color, #0877BC);
    color: #FFF;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}

.sessions-list {
    padding: 5px;
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
    list-style: none;
    margin: 0;
}

/* Container for Today's Training Sessions - match metrics container structure exactly */
.today-sessions {
    margin: 2px 8px !important; /* Match .metrics margin exactly */
    width: auto !important; /* Let browser calculate width based on margin */
    max-width: 100% !important;
    display: block !important;
    padding: 0 !important;
    box-sizing: border-box;
    position: relative;
}

/* Today's Training Sessions list container - match metrics-container exactly */
.today-sessions .sessions-list {
    display: block !important; /* Override grid display from general .sessions-list */
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 5px !important; /* Match .metrics-container padding exactly */
    margin: 0 !important;
    box-sizing: border-box;
    position: relative !important;
}

/* Remove ul/li styling for today-sessions since we're using Slide component */
.today-sessions .sessions-list ul {
    display: none; /* Hide ul since we're using Slide component */
}

/* Make Today's Training Sessions cards match metric cards (slideData) styling with background image */
.today-sessions .slideData.session-card {
    display: flex !important;
    align-items: stretch !important;
    gap: 18px !important;
    background: linear-gradient(135deg, #fff 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 7%, #fff) 100%) !important;
    border-radius: 16px !important;
    padding: 18px 18px 18px 164px !important;
    box-shadow: 0 8px 22px color-mix(in srgb, var(--brand-primary, #0877BC) 20%, transparent) !important;
    margin: 15px 10px !important;
    background-color: #fff !important;
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 22%, #fff) !important;
    transition: all 0.3s ease !important;
    position: relative !important;
    overflow: hidden !important;
    cursor: pointer !important;
    min-height: 188px !important;
    height: 188px !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), linear-gradient(135deg, #fff 0%, #f8f9fa 100%) !important;
    background-repeat: no-repeat, no-repeat !important;
    background-position: left center, center !important;
    background-size: 146px 100%, cover !important;
}

.today-sessions .slideData.session-card:hover {
    transform: translateY(-3px) !important;
    box-shadow: 0 12px 30px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent) !important;
}

.today-sessions .slideData.session-card::before {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 4px !important;
    background: linear-gradient(90deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 72%, #000) 100%) !important;
    z-index: 1 !important;
}

/* Ensure content styling matches metric cards */
.today-sessions .slideData.session-card .session-info.card-info {
    margin-left: 0 !important;
    padding-left: 0 !important;
    width: auto !important;
    flex: 1 1 !important;
    display: flex !important;
    flex-direction: column !important;
    text-align: left !important;
    overflow: hidden !important;
    max-height: 100% !important;
    justify-content: flex-start !important;
}

.today-session-group-tag {
    position: absolute;
    left: 8px;
    bottom: 8px;
    max-width: 136px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 8px;
    padding: 6px 9px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 70%, #000);
}

.today-session-side {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
    min-width: 92px;
}

.today-sessions .slideData.session-card .session-info h3 {
    color: var(--Black, #202226) !important;
    font-family: Poppins !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    margin: 0 0 8px 0 !important;
}

.today-sessions .slideData.session-card .session-info p {
    color: #838383 !important;
    font-family: Poppins !important;
    font-size: 14px !important;
    margin: 0 !important;
}

/* Ensure running/started sessions in Today's Training Sessions have green border */
.today-sessions .slideData.session-card.running {
    border: 2px solid #28a745 !important; /* Green border for running/started */
}

.today-sessions .slideData.session-card.active.running {
    border: 3px solid #28a745 !important; /* Green border for running state when selected */
}

/* Support for nested ul structure (SessionsList component) */
.sessions-list ul {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
    list-style: none;
    padding: 0;
    margin: 0;
}

.sessions-list > li,
.sessions-list ul li {
    display: flex;
    align-items: center;
    border-radius: 8px;
    padding: 15px;
    justify-content: space-between;
    background: #fff;
    cursor: pointer;
    min-height: 110px;
    height: auto;
    width: 100%;
    box-shadow: 0px 0px 5px color-mix(in srgb, var(--brand-primary, #0877BC) 35%, transparent);
    margin: 0;
    list-style: none;
}

/* Home date-filtered sessions: centered layout with larger cards */
/* Home date-filtered sessions: centered layout with larger cards */
.home-date-sessions .sessions-list {
    max-width: 1200px;
    margin: 0 auto;
    padding: 12px 10px !important;
}

.home-date-sessions .sessions-list ul {
    display: flex !important;
    flex-direction: column !important;
    gap: 14px !important;
    padding: 0 !important;
    margin: 0 !important;
    list-style: none !important;
}

.home-date-sessions .sessions-list > li,
.home-date-sessions .sessions-list ul li {
    min-height: auto !important;
    padding: 16px !important;
    gap: 16px !important;
    position: relative !important;
}

.home-date-sessions .sessions-list .session-info {
    width: auto !important;
    flex: 1 1 !important;
    min-width: 0 !important;
    max-width: 100% !important;
}

.home-date-sessions .sessions-list .session-info h3 {
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 1.3 !important;
    margin-bottom: 4px !important;
    color: var(--text-color, #ffffff) !important;
}

.home-date-sessions .sessions-list .session-info p {
    font-size: 12px !important;
    line-height: 1.35 !important;
}

.home-date-sessions .session-start {
    position: static !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-end !important;
    justify-content: center !important;
    gap: 8px !important;
    min-width: 90px !important;
}

.home-date-sessions .session-state {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 4px !important;
    padding: 4px 10px !important;
    border-radius: 20px !important;
    font-size: 10px !important;
    font-weight: 700 !important;
    letter-spacing: 0.03em !important;
    text-transform: uppercase !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: none !important;
}

.home-date-sessions .session_edit {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 8px !important;
}

/* Branded home date-filtered session cards */
@keyframes pulse {
    0% { transform: scale(1); opacity: 0.9; }
    50% { transform: scale(1.15); opacity: 1; filter: drop-shadow(0 0 6px rgba(255, 69, 58, 0.6)); }
    100% { transform: scale(1); opacity: 0.9; }
}

.home-date-sessions .home-session-card {
    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;
    backdrop-filter: blur(20px) !important;
    -webkit-backdrop-filter: blur(20px) !important;
    border: 1px solid var(--glass-border, rgba(8, 119, 188, 0.15)) !important;
    border-left: 4px solid var(--brand-secondary, #46528b) !important;
    box-shadow: 0 4px 20px var(--shadow-color, rgba(0, 0, 0, 0.25)) !important;
    border-radius: 14px !important;
    padding: 14px 18px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    color: var(--text-color, #ffffff) !important;
    cursor: pointer !important;
    display: flex !important;
    flex-direction: column !important; /* distributed on lines, not columns */
    position: relative !important;
    overflow: hidden !important;
    align-items: stretch !important;
    gap: 8px !important;
}

/* Hover state glow matched to branding and state */
.home-date-sessions .home-session-card:hover {
    transform: translateY(-2px) !important;
    border-color: rgba(8, 119, 188, 0.35) !important;
    box-shadow: 0 8px 24px rgba(8, 119, 188, 0.15), 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

.home-date-sessions .home-session-card.scheduled:hover {
    border-color: rgba(8, 119, 188, 0.4) !important;
    box-shadow: 0 8px 24px rgba(8, 119, 188, 0.12) !important;
}

.home-date-sessions .home-session-card.running:hover {
    border-color: rgba(8, 119, 188, 0.5) !important;
    box-shadow: 0 8px 24px rgba(8, 119, 188, 0.2) !important;
}

.home-date-sessions .home-session-card.paused:hover {
    border-color: rgba(255, 159, 10, 0.45) !important;
    box-shadow: 0 8px 24px rgba(255, 159, 10, 0.15) !important;
}

.home-date-sessions .home-session-card.finalized:hover {
    border-color: rgba(220, 53, 69, 0.5) !important;
    box-shadow: 0 8px 24px rgba(220, 53, 69, 0.18) !important;
}

.home-date-sessions .home-session-card:active {
    transform: translateY(0) scale(0.99) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
}

.home-date-sessions .home-session-card__accent {
    display: none !important;
}

.home-date-sessions .home-session-card__body {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    gap: 6px !important;
    min-width: 0 !important;
    flex: 1 1 !important;
    text-align: left !important;
}

.home-date-sessions .home-session-card__title-row {
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    flex-wrap: wrap !important;
}

.home-date-sessions .home-session-card__body h3 {
    color: var(--text-color, #ffffff) !important;
    font-size: 17px !important;
    font-weight: 700 !important;
    margin: 0 !important;
    line-height: 1.25 !important;
    letter-spacing: -0.3px !important;
}

.home-date-sessions .home-session-card__group {
    margin: 0 !important;
    font-size: 10px !important;
    font-weight: 700 !important;
    color: var(--brand-secondary, #30D5C8) !important;
    background: rgba(48, 213, 200, 0.1) !important;
    border: 1px solid rgba(48, 213, 200, 0.22) !important;
    padding: 2px 8px !important;
    border-radius: 20px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.04em !important;
}

.home-date-sessions .home-session-card__datetime {
    margin: 0 !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    color: var(--text-secondary, rgba(255, 255, 255, 0.5)) !important;
}

.home-date-sessions .home-session-card__hint {
    margin: 4px 0 0 !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    line-height: 1.35 !important;
    color: var(--text-secondary, rgba(255, 255, 255, 0.4)) !important;
    font-style: italic !important;
}

.home-date-sessions .home-session-card__meta {
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
    margin-top: 4px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    color: var(--text-secondary, rgba(255, 255, 255, 0.5)) !important;
    flex-wrap: wrap !important;
}

.home-date-sessions .home-session-card__meta-separator {
    color: var(--border-color, rgba(255, 255, 255, 0.25)) !important;
    font-size: 10px !important;
}

.home-date-sessions .home-session-card__difficulty {
    padding: 2px 8px !important;
    border-radius: 6px !important;
    font-size: 10px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    font-weight: 700 !important;
}

.home-date-sessions .home-session-card__difficulty--easy {
    background: rgba(50, 215, 75, 0.15) !important;
    color: #32D74B !important;
    border: 1px solid rgba(50, 215, 75, 0.25) !important;
}

.home-date-sessions .home-session-card__difficulty--medium {
    background: rgba(255, 159, 10, 0.15) !important;
    color: #FF9F0A !important;
    border: 1px solid rgba(255, 159, 10, 0.25) !important;
}

.home-date-sessions .home-session-card__difficulty--hard,
.home-date-sessions .home-session-card__difficulty--intense {
    background: rgba(255, 69, 58, 0.15) !important;
    color: #FF453A !important;
    border: 1px solid rgba(255, 69, 58, 0.25) !important;
}

.home-date-sessions .home-session-card__difficulty--pro,
.home-date-sessions .home-session-card__difficulty--extreme {
    background: rgba(191, 90, 242, 0.15) !important;
    color: #BF5AF2 !important;
    border: 1px solid rgba(191, 90, 242, 0.25) !important;
}

.home-date-sessions .home-session-card__aside {
    display: flex !important;
    flex-direction: row !important; /* side by side */
    align-items: center !important;
    justify-content: space-between !important; /* state badge on left, button/actions on right */
    gap: 8px !important;
    width: 100% !important;
    min-width: unset !important;
    margin-top: 6px !important;
    padding-top: 8px !important;
    border-top: 1px solid rgba(255, 255, 255, 0.06) !important;
}

.home-date-sessions .home-session-card__badge {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 4px !important;
    padding: 4px 10px !important;
    border-radius: 20px !important;
    font-size: 10px !important;
    font-weight: 700 !important;
    letter-spacing: 0.03em !important;
    text-transform: uppercase !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: none !important;
}

.home-date-sessions .home-session-card__badge--scheduled {
    background: rgba(191, 90, 242, 0.15) !important;
    color: #BF5AF2 !important;
    border: 1px solid rgba(191, 90, 242, 0.25) !important;
}

.home-date-sessions .home-session-card__badge--running {
    background: rgba(10, 132, 255, 0.15) !important;
    color: #0A84FF !important;
    border: 1px solid rgba(10, 132, 255, 0.3) !important;
}

.home-date-sessions .home-session-card__badge--paused {
    background: rgba(255, 159, 10, 0.15) !important;
    color: #FF9F0A !important;
    border: 1px solid rgba(255, 159, 10, 0.25) !important;
}

.home-date-sessions .home-session-card__badge--finalized {
    background: rgba(220, 53, 69, 0.12) !important;
    color: #dc3545 !important;
    border: 1px solid rgba(220, 53, 69, 0.28) !important;
}

.home-date-sessions .home-session-card__live-dot {
    width: 6px !important;
    height: 6px !important;
    background: #0A84FF !important;
    box-shadow: 0 0 8px #0A84FF !important;
    border-radius: 50% !important;
}

/* Started sessions: stronger brand presence */
.home-date-sessions .home-session-card--started {
    border-width: 1px !important;
}

.home-date-sessions .home-session-card.running {
    border-color: rgba(8, 119, 188, 0.45) !important;
    border-left: 4px solid var(--brand-primary, #0877BC) !important;
    box-shadow: 0 6px 20px rgba(8, 119, 188, 0.2) !important;
}

.home-date-sessions .home-session-card.running::before {
    display: none !important;
}

.home-date-sessions .home-session-card.paused {
    border-color: rgba(255, 159, 10, 0.35) !important;
    border-left: 4px solid #FF9F0A !important;
    box-shadow: 0 6px 20px rgba(255, 159, 10, 0.15) !important;
}

.home-date-sessions .home-session-card.paused::before {
    display: none !important;
}

.home-date-sessions .home-session-card.finalized {
    border-color: rgba(220, 53, 69, 0.4) !important;
    border-left: 4px solid #dc3545 !important;
    box-shadow: 0 6px 20px rgba(220, 53, 69, 0.15) !important;
}

.home-date-sessions .home-session-card.finalized::before {
    display: none !important;
}

.home-date-sessions .home-session-card.active {
    border-color: var(--brand-primary, #0877BC) !important;
}

.home-date-sessions .home-session-card .session_edit svg {
    color: var(--brand-primary, #0A84FF) !important;
}

.home-date-sessions .home-session-card.running .session_edit svg {
    color: var(--brand-primary, #0A84FF) !important;
}

/* Drills blueprint tags preview list styling */
.home-date-sessions .home-session-card__drills {
    margin-top: 6px !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 6px !important;
}

.home-date-sessions .home-session-card__drills-list {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 6px !important;
}

.home-date-sessions .home-session-card__drill-tag {
    display: inline-flex !important;
    align-items: center !important;
    gap: 6px !important;
    background: color-mix(in srgb, var(--text-color, #ffffff) 6%, transparent) !important;
    border: 1px solid color-mix(in srgb, var(--text-color, #ffffff) 12%, transparent) !important;
    border-radius: 8px !important;
    padding: 3px 8px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: color-mix(in srgb, var(--text-color, #ffffff) 80%, transparent) !important;
    line-height: 1.25 !important;
    transition: all 0.2s ease !important;
}

.home-date-sessions .home-session-card__drill-tag:hover {
    background: color-mix(in srgb, var(--text-color, #ffffff) 12%, transparent) !important;
    color: var(--text-color, #ffffff) !important;
    border-color: color-mix(in srgb, var(--text-color, #ffffff) 25%, transparent) !important;
}

.home-date-sessions .home-session-card__drill-dot {
    width: 5px !important;
    height: 5px !important;
    background: color-mix(in srgb, var(--text-color, #ffffff) 35%, transparent) !important;
    border-radius: 50% !important;
}

.home-date-sessions .home-session-card.running .home-session-card__drill-dot {
    background: #0A84FF !important;
    box-shadow: 0 0 5px #0A84FF !important;
}

.home-date-sessions .home-session-card.paused .home-session-card__drill-dot {
    background: #FF9F0A !important;
    box-shadow: 0 0 5px #FF9F0A !important;
}

.home-date-sessions .home-session-card.finalized .home-session-card__drill-dot {
    background: #dc3545 !important;
    box-shadow: 0 0 5px #dc3545 !important;
}

.home-date-sessions .home-session-card__drill-tag--more {
    background: color-mix(in srgb, var(--text-color, #ffffff) 10%, transparent) !important;
    color: color-mix(in srgb, var(--text-color, #ffffff) 60%, transparent) !important;
    font-weight: 600 !important;
}

/* Session card HR summary — same tiles as exercise result cards */
.home-date-sessions .home-session-card__hr-summary {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-top: 4px !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
}

.home-date-sessions .home-session-card__hr-summary-card {
    margin-bottom: 0 !important;
    padding: 10px 6px !important;
    box-shadow: none !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
    gap: 6px !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}

.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard {
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
    padding: 8px 4px !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
}

.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard-header {
    width: 100% !important;
    justify-content: center !important;
    text-align: center !important;
    flex-wrap: wrap !important;
    font-size: 9px !important;
    line-height: 1.15 !important;
    gap: 3px !important;
}

.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard-header span {
    white-space: normal !important;
    text-align: center !important;
    word-break: break-word !important;
}

.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard-value {
    font-size: 17px !important;
    max-width: 100% !important;
    text-align: center !important;
}

.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard-unit {
    font-size: 10px !important;
}

.home-date-sessions .home-session-card__hr-player-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 2px;
    padding: 0 2px;
    font-size: 10px;
    font-weight: 500;
    color: var(--brand-text-secondary, #6b7280);
    line-height: 1.2;
    white-space: normal !important;
    word-break: break-word;
    text-align: center;
    width: 100%;
    max-width: 100%;
    min-height: 2.4em;
    box-sizing: border-box;
}

/* Premium Heart Rate Widget design (legacy — replaced by hr-summary tiles) */
.home-date-sessions .home-session-card__hr-container {
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    padding: 8px 14px !important;
    border-radius: 12px !important;
    background: rgba(255, 69, 58, 0.05) !important;
    border: 1px solid rgba(255, 69, 58, 0.15) !important;
    margin-right: 6px !important;
    align-self: center !important;
    box-shadow: inset 0 0 10px rgba(255, 69, 58, 0.02) !important;
    transition: transform 0.2s ease, border-color 0.2s ease !important;
}

.home-date-sessions .home-session-card__hr-container:hover {
    border-color: rgba(255, 69, 58, 0.3) !important;
    transform: scale(1.02) !important;
}

.home-date-sessions .home-session-card__hr-icon {
    font-size: 20px !important;
    color: #FF453A !important;
    animation: pulse 1.8s infinite ease-in-out !important;
}

.home-date-sessions .home-session-card__hr-stats {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
}

.home-date-sessions .home-session-card__hr-stat {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
}

.home-date-sessions .home-session-card__hr-label {
    font-size: 8px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    color: var(--text-secondary, rgba(255, 255, 255, 0.4)) !important;
    letter-spacing: 0.06em !important;
    line-height: 1 !important;
    margin-bottom: 2px !important;
}

.home-date-sessions .home-session-card__hr-value {
    font-size: 13px !important;
    font-weight: 700 !important;
    color: var(--text-color, #ffffff) !important;
    font-family: SF Pro Text, -apple-system, monospace !important;
    line-height: 1.15 !important;
}

.home-date-sessions .home-session-card__hr-divider {
    width: 1px !important;
    height: 20px !important;
    background: var(--border-color, rgba(255, 255, 255, 0.1)) !important;
}

/* Override generic session-list state colors inside home date filter */
.home-date-sessions .sessions-list ul li.home-session-card {
    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;
    border: 1px solid var(--glass-border, rgba(8, 119, 188, 0.15)) !important;
    color: var(--text-color, #ffffff) !important;
    box-shadow: 0 4px 20px var(--shadow-color, rgba(0, 0, 0, 0.25)) !important;
}

.home-date-sessions .sessions-list ul li.home-session-card.scheduled {
    border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08)) !important;
    background: var(--glass-bg, rgba(20, 20, 22, 0.65)) !important;
}

.home-date-sessions .sessions-list ul li.home-session-card.scheduled::before {
    content: "" !important;
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    width: 4px !important;
    background: #BF5AF2 !important;
}

.home-date-sessions .sessions-list ul li.home-session-card.running {
    border-color: rgba(10, 132, 255, 0.4) !important;
    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;
}

.home-date-sessions .sessions-list ul li.home-session-card.paused {
    border-color: rgba(255, 159, 10, 0.35) !important;
    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;
}

.home-date-sessions .sessions-list ul li.home-session-card.finalized {
    border-color: rgba(220, 53, 69, 0.4) !important;
    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;
}

.home-date-sessions .sessions-list ul li.home-session-card.active,
.home-date-sessions .sessions-list ul li.home-session-card.home-session-card--selected,
.home-date-sessions .sessions-list ul li.home-session-card.active.running,
.home-date-sessions .sessions-list ul li.home-session-card.active.paused,
.home-date-sessions .sessions-list ul li.home-session-card.active.finalized,
.home-date-sessions .sessions-list ul li.home-session-card.active.scheduled {
    border: 2px solid var(--brand-primary, #0A84FF) !important;
    background: color-mix(
        in srgb,
        var(--brand-primary, #0A84FF) 18%,
        var(--glass-bg, rgba(18, 22, 33, 0.75))
    ) !important;
    box-shadow:
        0 0 0 3px color-mix(in srgb, var(--brand-primary, #0A84FF) 40%, transparent),
        0 10px 28px color-mix(in srgb, var(--brand-primary, #0A84FF) 28%, transparent) !important;
}

.home-date-sessions .sessions-list ul li.home-session-card.active .session-info h3 {
    color: var(--text-color, #ffffff) !important;
}

.home-date-sessions .sessions-list ul li.home-session-card.active::before {
    display: none !important;
}

.sessions-list > li.active,
.sessions-list ul li.active {
    border: 3px solid var(--brand-primary, #0877BC);
    box-shadow: 0px 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 45%, transparent);
    transform: translateY(-2px);
    transition: all 0.3s ease;
    background-color: #fff; /* White background */
    position: relative;
}

/* Session State Colors - White background with colored borders based on state */
.sessions-list > li.scheduled,
.sessions-list ul li.scheduled {
    background-color: #fff !important; /* White background */
    border: 2px solid #6c757d; /* Gray border for scheduled */
}

.sessions-list > li.running,
.sessions-list ul li.running {
    background-color: #fff !important; /* White background */
    border: 2px solid #28a745 !important; /* Green border for running/started */
}

.sessions-list > li.paused,
.sessions-list ul li.paused {
    background-color: #fff; /* White background */
    border: 2px solid #ffc107; /* Yellow border for paused */
}

.sessions-list > li.finalized,
.sessions-list ul li.finalized {
    background-color: #fff; /* White background */
    border: 2px solid #dc3545; /* Red border for finalized */
}

/* Combined states: active + state - Only selected cards change border color based on state */
.sessions-list > li.active.scheduled,
.sessions-list ul li.active.scheduled {
    border: 3px solid #6c757d; /* Gray border for scheduled state when selected */
    background-color: #fff !important; /* White background */
}

.sessions-list > li.active.running,
.sessions-list ul li.active.running {
    border: 3px solid #28a745 !important; /* Green border for running state when selected */
    background-color: #fff !important; /* White background */
}

.sessions-list > li.active.paused,
.sessions-list ul li.active.paused {
    border: 3px solid #ffc107; /* Yellow border for paused state when selected */
    background-color: #fff; /* White background */
}

.sessions-list > li.active.finalized,
.sessions-list ul li.active.finalized {
    border: 3px solid #dc3545; /* Red border for finalized state when selected */
    background-color: #fff; /* White background */
}

/* Homepage calendar list: the chosen session stays branded, in every state. */
.home-theme-root .home-date-sessions .sessions-list ul li.home-session-card.home-session-card--selected,
.home-theme-root .sessions-list ul li.home-session-card.home-session-card--selected {
    border: 2px solid var(--brand-primary, #0A84FF) !important;
    background: color-mix(
        in srgb,
        var(--brand-primary, #0A84FF) 18%,
        var(--surface-color, #121621)
    ) !important;
    box-shadow:
        0 0 0 3px color-mix(in srgb, var(--brand-primary, #0A84FF) 40%, transparent),
        0 10px 28px color-mix(in srgb, var(--brand-primary, #0A84FF) 28%, transparent) !important;
}

/* Ensure text is readable in finalized cards */
.sessions-list > li.finalized .session-info h3,
.sessions-list > li.finalized .session-info p,
.sessions-list > li.active.finalized .session-info h3,
.sessions-list > li.active.finalized .session-info p {
    color: #333 !important;
    opacity: 1 !important;
}

.sessions-list > li.active::before,
.sessions-list ul li.active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: var(--brand-primary, #0877BC);
    border-radius: 8px 0 0 8px;
}

.sessions-list > li.active .session_imgbox,
.sessions-list ul li.active .session_imgbox {
    border-color: var(--brand-primary, #0877BC);
    background-color: color-mix(in srgb, var(--brand-primary, #0877BC) 12%, #fff);
}

.sessions-list > li.active .session-info h3,
.sessions-list ul li.active .session-info h3 {
    color: var(--brand-primary, #0877BC);
    font-weight: 700;
}

/* Ensure text is readable in active finalized cards */
.sessions-list > li.active.finalized .session-info h3 {
    color: var(--brand-primary, #0877BC) !important;
    font-weight: 700;
}

.sessions-list > li.active.finalized .session-info p {
    color: #333 !important;
    opacity: 1 !important;
}

/* Removed duplicate finalized styles - using the new finalized styles above */

.sessions-list > li.onprogress,
.sessions-list ul li.onprogress {
    background: #a62d32;
    color: #fff;
}

.onprogress .session-state {
    background-color: #fff;
    color: #a62d32
}

.onprogress .session-info p {
    color: #ffffffd5 !important;
}

/* .sessions-list ul li.active h3,
.sessions-list ul li.active p {
    color: #ffffff;
} */

.session-image-add {
    width: 16%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--brand-primary, #0877BC);
    border-radius: 8px;
    padding: 10px;

}

.session-image-add2 {
    width: 16%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding: 5px;
    border: 2px solid var(--brand-primary, #0877BC);
    background-color: var(--brand-primary, #0877BC);
}

.session-image-add img,
.session-image-add2 img {
    height: 100%;
    width: auto;
    object-fit: contain; /* Preserve aspect ratio */
    max-width: 100%;
}

.session-image-add2 svg {
    width: 30px;
    height: 30px;
    color: #fff;
}


.sessions-list .session-image {
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 8px;


}

.select_msg {
    font-size: 14px;
    text-align: center;
    margin: 20px;
    font-weight: bold;
    color: #0877BC;
}

.session-image {
    border: 1px solid #0877BC;
    border-radius: 8px;

}

.session-image-select {
    border: 1px solid #0877BC;
    padding: 10px;
}

.session-image-select>img {
    width: 30px;
}

.session-addinfo {
    font-size: 13px;
    padding-right: 80px;
}

.session_imgbox {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--brand-primary, #0877BC);
    border-radius: 8px;
    padding: 3px 20px;
    background-color: #fff;
    object-fit: contain; /* Preserve aspect ratio */
    max-width: 100%;
    max-height: 100%;
    width: 60px; /* Fixed width for consistent sizing */
    min-width: 60px; /* Ensure minimum width */
}

.session_imgbox img {
    width: 50px; /* Fixed width for the icon */
    height: 50px; /* Fixed height for the icon */
    object-fit: contain; /* Preserve aspect ratio */
}

.sessions-list .session-info {
    width: 45%;
}

.sessions-list .session-info h3 {
    font-size: 16px !important;
}

.sessions-list .session-info p {
    font-size: 12px !important;
    color: #7c7a7a;
    font-weight: 600;
}

.sessions-list .session-start img {
    width: 30px;
    margin-right: 5px;
}

.select_sessions_info {
    background-color: #fff;
    min-width: 300px;
    max-width: max-content;
    box-shadow: 0 0 5px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent);
    display: flex;
    padding: 10px;
    align-items: center;
    gap: 20px;
    position: relative;

}

.selectedsession_imgbox {
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--brand-primary, #0877BC);
    border-radius: 8px;
    padding: 3px 13px;
    background: #fff
}

/* Add Training Session Card - standalone card for calendar section */
.session_add_box_add_card {
    display: flex;
    align-items: center;
    gap: 15px;
    border-radius: 8px;
    margin: 0;
    padding: 15px 20px;
    background: var(--brand-primary, #0877BC);
    cursor: pointer;
    height: 75px;
    box-shadow: 0 0 5px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent);
    width: 100%;
    max-width: 100%;
    transition: all 0.3s ease;
}

.session_add_box_add_card:hover {
    background: var(--brand-primary-dark, #065a94);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 50%, transparent);
    transform: translateY(-2px);
}

.session-image-add-square {
    width: 50px;
    height: 50px;
    min-width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

/* Calendar date-selector section */
.calendar-and-add-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 12px auto 16px;
    max-width: 1200px;
    padding: 0 10px;
    box-sizing: border-box;
}

.calendar-and-add-section .home-date-sessions-with-calendar {
    width: 100%;
    animation: dateRangePanelIn 0.22s ease both;
}

.calendar-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100%;
    max-width: 420px;
}

.calendar-wrapper .date_info {
    width: 100%;
}

.add-session-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
}

@media(max-width:1150px) {
    /* Today's Training Sessions - keep one per line on mobile too */
    .today-sessions .sessions-list {
        grid-template-columns: 1fr;
    }
    .sessions-list ul {
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    }
    
    /* Today's Training Sessions - keep one per line on mobile too */
    .today-sessions .sessions-list ul {
        grid-template-columns: 1fr;
    }
}

/* On mobile: stack "select a date" message above the calendar so calendar is fully visible */
@media (max-width: 768px) {
    .calendar-and-add-section {
        flex-direction: column;
        align-items: stretch;
    }
    .calendar-and-add-section .calendar-wrapper {
        width: 100%;
    }
}

@media(max-width:750px) {
    .session_imgbox {
        padding: 10px 6px;
        width: 50px;
        height: auto;
    }

    .sessions-list .session-info h3 {
        font-size: 15px !important;

    }

    .sessions-list ul li {
        padding: 10px 5px;
        width: calc(100% - 10px);
        margin: 10px 5px
    }

    .home-date-sessions .sessions-list ul {
        grid-template-columns: 1fr;
    }

    .home-date-sessions .sessions-list > li,
    .home-date-sessions .sessions-list ul li {
        min-height: 118px;
        padding: 14px 56px 14px 12px;
    }
    
    /* Override for Today's Training Sessions to maintain full width */
    .today-sessions .sessions-list ul li {
        width: 100% !important;
        margin: 0 !important;
        padding: 18px 18px 18px 160px !important;
    }

    .sessions-list ul {
        gap: 0px;
    }



}

@media(max-width:650px) {
    .filter {
        min-width: 50px;
        font-size: 11px;
    }

    .training-options-filter {
        gap: 10px;
    }

    .session-image-add {
        width: 90px
    }

    .session-addinfo {
        padding-right: 10px;
    }

    .sessions-list ul {
        grid-template-columns: auto;
    }
    
    /* Today's Training Sessions - keep one per line on small screens */
    .today-sessions .sessions-list ul {
        grid-template-columns: 1fr;
    }

    /* Add Session Card responsive */
    .calendar-wrapper {
        max-width: 100%;
        padding: 0 10px;
    }

    .session_add_box_add_card {
        width: 100%;
        max-width: 100%;
    }
}

/* Seasonal "add sessions" modal — brand-aware (uses CSS vars from BrandContext) */
.seasonal-session-modal .seasonal-session-title {
    font-size: 17px;
    color: var(--brand-primary, #0877BC);
    text-align: left;
    margin: 0 0 8px;
    font-weight: 600;
}

.seasonal-session-modal button.seasonal-session-submit {
    width: 100%;
    padding: 12px 16px;
    margin-top: 8px;
    background: var(--brand-primary, #0877BC);
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    transition: background 0.2s ease;
}

.seasonal-session-modal button.seasonal-session-submit:hover {
    background: var(--brand-primary-dark, #065a94);
}

/* Add / seasonal / duplicate session dialogs — light + dark mode */
.session-add-dialog {
    color: var(--text-color);
    background: var(--surface-color);
    color-scheme: light;
}

html[data-theme="dark"] .session-add-dialog,
html.dark-mode .session-add-dialog,
.dark-mode .session-add-dialog {
    color-scheme: dark;
}

.session-add-dialog__field {
    margin-top: 16px;
    text-align: left;
}

.session-add-dialog__field > label,
.session-add-dialog .input-detail > label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 0.875rem;
    color: var(--text-color) !important;
}

.session-add-dialog__input,
.session-add-dialog .input-detail input[type="time"],
.session-add-dialog .input-detail input[type="number"] {
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    background: var(--surface-color);
    color: var(--text-color);
    color-scheme: light;
    box-sizing: border-box;
}

html[data-theme="dark"] .session-add-dialog__input,
html.dark-mode .session-add-dialog__input,
.dark-mode .session-add-dialog__input,
html[data-theme="dark"] .session-add-dialog .input-detail input[type="time"],
html.dark-mode .session-add-dialog .input-detail input[type="time"],
.dark-mode .session-add-dialog .input-detail input[type="time"],
html[data-theme="dark"] .session-add-dialog .input-detail input[type="number"],
html.dark-mode .session-add-dialog .input-detail input[type="number"],
.dark-mode .session-add-dialog .input-detail input[type="number"] {
    color-scheme: dark;
}

.session-add-dialog input[type="time"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    opacity: 1;
    filter: none;
}

html[data-theme="dark"] .session-add-dialog input[type="time"]::-webkit-calendar-picker-indicator,
html.dark-mode .session-add-dialog input[type="time"]::-webkit-calendar-picker-indicator,
.dark-mode .session-add-dialog input[type="time"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
}

.session-add-dialog__duration {
    display: flex;
    align-items: center;
    gap: 10px;
}

.session-add-dialog__duration label {
    margin: 0 !important;
    color: var(--text-secondary) !important;
    font-weight: 500 !important;
}

.session-add-dialog__calendar {
    background: var(--surface-color);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    overflow: hidden;
}

.session-add-dialog__calendar .rdrCalendarWrapper,
.session-add-dialog__calendar .rdrDateDisplayWrapper,
.session-add-dialog__calendar .rdrMonth {
    background: var(--surface-color) !important;
    color: var(--text-color) !important;
}

.session-add-dialog__calendar .rdrMonthAndYearPickers select,
.session-add-dialog__calendar .rdrWeekDay,
.session-add-dialog__calendar .rdrDayNumber span {
    color: var(--text-color) !important;
}

.session-add-dialog__calendar .rdrDayPassive .rdrDayNumber span {
    color: var(--text-secondary) !important;
    opacity: 0.55;
}

.session-add-dialog__calendar .rdrDayDisabled {
    background-color: transparent !important;
}

.session-add-dialog__calendar .rdrDayToday .rdrDayNumber span:after {
    background: var(--brand-primary, #0877BC) !important;
}

.session-add-dialog__calendar .rdrSelected,
.session-add-dialog__calendar .rdrDayStartPreview,
.session-add-dialog__calendar .rdrDayEndPreview,
.session-add-dialog__calendar .rdrDayInPreview {
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 22%, transparent) !important;
}

.session-add-dialog__calendar .rdrDayHovered .rdrDayNumber span,
.session-add-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrDayNumber span {
    color: var(--text-color) !important;
}

.session-add-dialog__calendar .rdrNextPrevButton {
    background: color-mix(in srgb, var(--text-color) 8%, var(--surface-color)) !important;
}

.session-add-dialog__calendar .rdrNextPrevButton i {
    border-color: var(--text-color) !important;
}

.session-add-dialog__calendar .rdrPprevButton i {
    border-color: var(--text-color) !important;
}

.dark-mode .session-add-dialog__calendar .rdrDayNumber span,
html.dark-mode .session-add-dialog__calendar .rdrDayNumber span {
    color: var(--text-color) !important;
}

.dark-mode .session-add-dialog__calendar .rdrWeekDay,
html.dark-mode .session-add-dialog__calendar .rdrWeekDay {
    color: var(--text-secondary) !important;
}

.session-readonly-banner {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    max-width: 1100px;
    margin: 0 auto 14px;
    padding: 10px 14px;
    border-radius: 8px;
    background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);
    color: var(--text-color);
    font-size: 13px;
}

.session-readonly-banner__icon {
    color: var(--brand-primary, #0877bc);
    font-size: 22px !important;
    margin-top: 1px;
    flex-shrink: 0;
}

.session-readonly-banner__text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    color: var(--text-secondary);
}

.session-readonly-banner__text strong {
    color: var(--brand-primary, #0877bc);
    font-weight: 700;
}

/* Custom premium additions for date-filtered sessions */
.home-sessions-loading-state {
    padding: 24px 20px !important;
    text-align: center !important;
    color: rgba(255, 255, 255, 0.6) !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    background: rgba(18, 19, 23, 0.4) !important;
    border-radius: 16px !important;
    border: 1px solid rgba(255, 255, 255, 0.05) !important;
    backdrop-filter: blur(12px) !important;
    -webkit-backdrop-filter: blur(12px) !important;
    margin-bottom: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 10px !important;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.home-sessions-loading-spinner {
    width: 16px !important;
    height: 16px !important;
    border: 2px solid rgba(255, 255, 255, 0.15) !important;
    border-top: 2px solid var(--brand-primary, #0A84FF) !important;
    border-radius: 50% !important;
    animation: spin 0.8s linear infinite !important;
    display: inline-block !important;
}

.home-sessions-empty-state {
    padding: 28px 20px !important;
    text-align: center !important;
    color: rgba(255, 255, 255, 0.45) !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    margin-bottom: 12px !important;
    background: rgba(18, 19, 23, 0.4) !important;
    border: 1px dashed rgba(255, 255, 255, 0.1) !important;
    border-radius: 16px !important;
    backdrop-filter: blur(12px) !important;
    -webkit-backdrop-filter: blur(12px) !important;
}

/* Premium action buttons inside the date-filtered session cards */
.home-date-sessions .deactive_btn {
    background: linear-gradient(135deg, var(--brand-primary, #0A84FF) 0%, #0056b3 100%) !important;
    border: 1px solid rgba(10, 132, 255, 0.25) !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    border-radius: 10px !important;
    padding: 6px 14px !important;
    font-size: 11px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    cursor: pointer !important;
    box-shadow: 0 4px 12px rgba(10, 132, 255, 0.2) !important;
    transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s ease, filter 0.2s ease !important;
    margin: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 1.2 !important;
}

.home-date-sessions .deactive_btn:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 16px rgba(10, 132, 255, 0.35) !important;
    filter: brightness(1.1) !important;
}

.home-date-sessions .deactive_btn:active {
    transform: translateY(0) !important;
}

/* Glassmorphic icon buttons inside the session cards */
.home-date-sessions .session_edit p {
    margin: 0 !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 10px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: rgba(255, 255, 255, 0.04) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    color: rgba(255, 255, 255, 0.75) !important;
    cursor: pointer !important;
    transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.2s ease, border-color 0.2s ease, color 0.2s ease !important;
}

.home-date-sessions .session_edit p:hover {
    transform: translateY(-2px) !important;
    background: rgba(255, 255, 255, 0.08) !important;
    color: #ffffff !important;
    border-color: rgba(255, 255, 255, 0.18) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.home-date-sessions .session_edit p:active {
    transform: translateY(0) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Session.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;;AAEjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uEAAuE;IACvE,6EAA6E;IAC7E,oCAAoC;IACpC,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,yFAAyF;AAC7F;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,+CAA+C;IAC/C,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,4EAA4E;AAC5E;IACI,oCAAoC,EAAE,4BAA4B;IAClE,sBAAsB,EAAE,4BAA4B;IACpD,gBAAgB;AACpB;;AAEA,+EAA+E;AAC/E;;IAEI,oCAAoC,EAAE,oCAAoC;IAC1E,sBAAsB,EAAE,4BAA4B;AACxD;;AAEA;;IAEI,oCAAoC,EAAE,qCAAqC;IAC3E,sBAAsB,EAAE,4BAA4B;AACxD;;AAEA;;IAEI,oCAAoC,EAAE,sCAAsC;IAC5E,sBAAsB,EAAE,6CAA6C;AACzE;;AAEA;;IAEI,oCAAoC,EAAE,mCAAmC;IACzE,sBAAsB,EAAE,4BAA4B;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;IAChB,SAAS;AACb;;AAEA,wFAAwF;AACxF;IACI,0BAA0B,EAAE,kCAAkC;IAC9D,sBAAsB,EAAE,gDAAgD;IACxE,0BAA0B;IAC1B,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,+EAA+E;AAC/E;IACI,yBAAyB,EAAE,sDAAsD;IACjF,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB,EAAE,6CAA6C;IACxE,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA,8EAA8E;AAC9E;IACI,aAAa,EAAE,8CAA8C;AACjE;;AAEA,sGAAsG;AACtG;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,oBAAoB;IACpB,wHAAwH;IACxH,8BAA8B;IAC9B,wCAAwC;IACxC,oGAAoG;IACpG,4BAA4B;IAC5B,iCAAiC;IACjC,wFAAwF;IACxF,oCAAoC;IACpC,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,wBAAwB;IACxB,oHAAoH;IACpH,kDAAkD;IAClD,mDAAmD;IACnD,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;IACtC,qGAAqG;AACzG;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iJAAiJ;IACjJ,qBAAqB;AACzB;;AAEA,gDAAgD;AAChD;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uEAAuE;AAC3E;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA,mFAAmF;AACnF;IACI,oCAAoC,EAAE,qCAAqC;AAC/E;;AAEA;IACI,oCAAoC,EAAE,iDAAiD;AAC3F;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,0FAA0F;IAC1F,SAAS;IACT,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE,mEAAmE;AACnE;IACI,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;IAC3B,wBAAwB;IACxB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,oBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,gCAAgC;IAChC,kCAAkC;IAClC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;IACnB,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,oCAAoC;IACpC,qDAAqD;IACrD,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA,6CAA6C;AAC7C;IACI,KAAK,mBAAmB,EAAE,YAAY,EAAE;IACxC,MAAM,sBAAsB,EAAE,UAAU,EAAE,mDAAmD,EAAE;IAC/F,OAAO,mBAAmB,EAAE,YAAY,EAAE;AAC9C;;AAEA;IACI,8DAA8D;IAC9D,sCAAsC;IACtC,8CAA8C;IAC9C,yEAAyE;IACzE,iEAAiE;IACjE,0EAA0E;IAC1E,8BAA8B;IAC9B,6BAA6B;IAC7B,6DAA6D;IAC7D,4CAA4C;IAC5C,0BAA0B;IAC1B,wBAAwB;IACxB,iCAAiC,EAAE,sCAAsC;IACzE,6BAA6B;IAC7B,2BAA2B;IAC3B,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,sCAAsC;IACtC,gDAAgD;IAChD,uFAAuF;AAC3F;;AAEA;IACI,+CAA+C;IAC/C,yDAAyD;AAC7D;;AAEA;IACI,+CAA+C;IAC/C,wDAAwD;AAC5D;;AAEA;IACI,iDAAiD;IACjD,0DAA0D;AAC9D;;AAEA;IACI,+CAA+C;IAC/C,yDAAyD;AAC7D;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;AACxD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,oBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,4CAA4C;IAC5C,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;IACpB,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,iDAAiD;IACjD,8CAA8C;IAC9C,qDAAqD;IACrD,2BAA2B;IAC3B,8BAA8B;IAC9B,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,iEAAiE;AACrE;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,iEAAiE;IACjE,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,iEAAiE;IACjE,0BAA0B;AAC9B;;AAEA;IACI,gEAAgE;IAChE,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;IAC1B,oCAAoC;IACpC,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;;IAEI,8CAA8C;IAC9C,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;;IAEI,+CAA+C;IAC/C,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,wBAAwB;IACxB,8BAA8B,EAAE,iBAAiB;IACjD,8BAA8B;IAC9B,yCAAyC,EAAE,iDAAiD;IAC5F,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,0DAA0D;AAC9D;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;IACnB,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,oCAAoC;IACpC,qDAAqD;IACrD,2BAA2B;AAC/B;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;IAC9B,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA,8CAA8C;AAC9C;IACI,4BAA4B;AAChC;;AAEA;IACI,gDAAgD;IAChD,+DAA+D;IAC/D,wDAAwD;AAC5D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iDAAiD;IACjD,yCAAyC;IACzC,0DAA0D;AAC9D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,+CAA+C;IAC/C,yCAAyC;IACzC,yDAAyD;AAC7D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA,+CAA+C;AAC/C;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,mBAAmB;IACnB,qFAAqF;IACrF,4FAA4F;IAC5F,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,iFAAiF;IACjF,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,sFAAsF;IACtF,4CAA4C;IAC5C,wFAAwF;AAC5F;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sFAAsF;IACtF,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,sFAAsF;IACtF,iFAAiF;IACjF,2BAA2B;AAC/B;;AAEA,kEAAkE;AAClE;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,iCAAiC;IACjC,mBAAmB;IACnB,2DAA2D;AAC/D;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,2CAA2C;IAC3C,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,6EAA6E;AAC7E;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,4BAA4B;IAC5B,8BAA8B;IAC9B,8CAA8C;IAC9C,oDAAoD;IACpD,4BAA4B;IAC5B,6BAA6B;IAC7B,6DAA6D;IAC7D,kEAAkE;AACtE;;AAEA;IACI,+CAA+C;IAC/C,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,oCAAoC;IACpC,iEAAiE;IACjE,iCAAiC;IACjC,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4CAA4C;IAC5C,6DAA6D;IAC7D,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,oEAAoE;AACxE;;AAEA,uEAAuE;AACvE;IACI,8DAA8D;IAC9D,yEAAyE;IACzE,4CAA4C;IAC5C,0EAA0E;AAC9E;;AAEA;IACI,2EAA2E;IAC3E,8DAA8D;AAClE;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,gDAAgD;IAChD,8DAA8D;AAClE;;AAEA;IACI,iDAAiD;IACjD,8DAA8D;AAClE;;AAEA;IACI,+CAA+C;IAC/C,8DAA8D;AAClE;;AAEA;;;;;;IAMI,0DAA0D;IAC1D;;;;gBAIY;IACZ;;iGAE6F;AACjG;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,+CAA+C;IAC/C,2FAA2F;IAC3F,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB,EAAE,qBAAqB;IAC7C,kBAAkB;AACtB;;AAEA,gFAAgF;AAChF;;IAEI,iCAAiC,EAAE,qBAAqB;IACxD,yBAAyB,EAAE,8BAA8B;AAC7D;;AAEA;;IAEI,iCAAiC,EAAE,qBAAqB;IACxD,oCAAoC,EAAE,qCAAqC;AAC/E;;AAEA;;IAEI,sBAAsB,EAAE,qBAAqB;IAC7C,yBAAyB,EAAE,6BAA6B;AAC5D;;AAEA;;IAEI,sBAAsB,EAAE,qBAAqB;IAC7C,yBAAyB,EAAE,6BAA6B;AAC5D;;AAEA,6FAA6F;AAC7F;;IAEI,yBAAyB,EAAE,kDAAkD;IAC7E,iCAAiC,EAAE,qBAAqB;AAC5D;;AAEA;;IAEI,oCAAoC,EAAE,iDAAiD;IACvF,iCAAiC,EAAE,qBAAqB;AAC5D;;AAEA;;IAEI,yBAAyB,EAAE,iDAAiD;IAC5E,sBAAsB,EAAE,qBAAqB;AACjD;;AAEA;;IAEI,yBAAyB,EAAE,iDAAiD;IAC5E,sBAAsB,EAAE,qBAAqB;AACjD;;AAEA,8EAA8E;AAC9E;;IAEI,0DAA0D;IAC1D;;;;gBAIY;IACZ;;iGAE6F;AACjG;;AAEA,+CAA+C;AAC/C;;;;IAII,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;;IAEI,2CAA2C;IAC3C,6EAA6E;AACjF;;AAEA;;IAEI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA,sDAAsD;AACtD;IACI,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,8EAA8E;;AAE9E;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;GAGG;;AAEH;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C;IAC/C,kBAAkB;IAClB,aAAa;;AAEjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,+CAA+C;IAC/C,+CAA+C;AACnD;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,mBAAmB,EAAE,0BAA0B;IAC/C,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;;AAGA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;;;AAGtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;;AAEtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C;IAC/C,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB,EAAE,0BAA0B;IAC/C,eAAe;IACf,gBAAgB;IAChB,WAAW,EAAE,sCAAsC;IACnD,eAAe,EAAE,yBAAyB;AAC9C;;AAEA;IACI,WAAW,EAAE,6BAA6B;IAC1C,YAAY,EAAE,8BAA8B;IAC5C,mBAAmB,EAAE,0BAA0B;AACnD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,sFAAsF;IACtF,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;;AAEtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C;IAC/C,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,YAAY;IACZ,sFAAsF;IACtF,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;IAC9C,yFAAyF;IACzF,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gEAAgE;IAChE;QACI,0BAA0B;IAC9B;IACA;QACI,4DAA4D;IAChE;;IAEA,gEAAgE;IAChE;QACI,0BAA0B;IAC9B;AACJ;;AAEA,6FAA6F;AAC7F;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;;IAE9B;;IAEA;QACI,iBAAiB;QACjB,wBAAwB;QACxB;IACJ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,iBAAiB;QACjB,4BAA4B;IAChC;;IAEA,kEAAkE;IAClE;QACI,sBAAsB;QACtB,oBAAoB;QACpB,wCAAwC;IAC5C;;IAEA;QACI,QAAQ;IACZ;;;;AAIJ;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA,mEAAmE;IACnE;QACI,0BAA0B;IAC9B;;IAEA,gCAAgC;IAChC;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,kFAAkF;AAClF;IACI,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,8CAA8C;AAClD;;AAEA,mEAAmE;AACnE;IACI,wBAAwB;IACxB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;IACrC,gCAAgC;IAChC,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;;;;;;;;IASI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,YAAY;AAChB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;;IAGI,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;;;IAGI,mCAAmC;AACvC;;AAEA;IACI,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oDAAoD;AACxD;;AAEA;;;;IAII,yFAAyF;AAC7F;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,qFAAqF;AACzF;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,uFAAuF;IACvF,oFAAoF;IACpF,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA,wDAAwD;AACxD;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,0CAA0C;IAC1C,0BAA0B;IAC1B,2BAA2B;IAC3B,4CAA4C;IAC5C,8BAA8B;IAC9B,sDAAsD;IACtD,sCAAsC;IACtC,8CAA8C;IAC9C,8BAA8B;IAC9B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sDAAsD;IACtD,8DAA8D;IAC9D,6BAA6B;IAC7B,+CAA+C;IAC/C,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,2CAA2C;IAC3C,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,4CAA4C;IAC5C,sDAAsD;IACtD,8BAA8B;IAC9B,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA,kEAAkE;AAClE;IACI,8FAA8F;IAC9F,qDAAqD;IACrD,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,4BAA4B;IAC5B,0BAA0B;IAC1B,oCAAoC;IACpC,iCAAiC;IACjC,0BAA0B;IAC1B,yDAAyD;IACzD,+GAA+G;IAC/G,oBAAoB;IACpB,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,0DAA0D;IAC1D,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA,uDAAuD;AACvD;IACI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,gDAAgD;IAChD,sDAAsD;IACtD,2CAA2C;IAC3C,0BAA0B;IAC1B,sIAAsI;AAC1I;;AAEA;IACI,sCAAsC;IACtC,gDAAgD;IAChD,yBAAyB;IACzB,kDAAkD;IAClD,qDAAqD;AACzD;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".training-options-filter {\n    display: flex;\n    margin-top: 0 !important;\n    margin: 20px 12px;\n    padding-bottom: 7px;\n    justify-content: space-around;\n\n}\n\n.hr_info_session {\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n}\n\n.sessionselectedgrp {\n    color: #343339;\n    font-size: 15px;\n    font-weight: 600;\n    margin: 15px 10px;\n}\n\n.session_edit {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n.session_edit p {\n    margin: 0;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 10%, #fff);\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 22%, #fff);\n    color: var(--brand-primary, #0877BC);\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.session_edit p:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 10px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent);\n}\n\n.deactive_btn {\n    background-color: #d31212;\n    border-radius: 8px;\n    margin: 6px;\n    padding: 3px 16px;\n    color: #fff;\n    font-size: 13px;\n    border: none;\n    outline: none;\n}\n\n.session-state {\n    font-size: 11px;\n    border-radius: 5px;\n    background-color: var(--brand-primary, #0877BC);\n    color: #fff;\n    padding: 3px 8px;\n    font-weight: 600;\n}\n\n/* Session state badges with better contrast for Today's Training Sessions */\n.today-sessions .session-state {\n    background-color: #0877BC !important; /* Default blue background */\n    color: #fff !important; /* White text for contrast */\n    font-weight: 600;\n}\n\n/* State-specific colors for session-state badge in Today's Training Sessions */\n.today-sessions .sessions-list > li.scheduled .session-state,\n.today-sessions .sessions-list ul li.scheduled .session-state {\n    background-color: #6c757d !important; /* Gray background to match border */\n    color: #fff !important; /* White text for contrast */\n}\n\n.today-sessions .sessions-list > li.running .session-state,\n.today-sessions .sessions-list ul li.running .session-state {\n    background-color: #28a745 !important; /* Green background to match border */\n    color: #fff !important; /* White text for contrast */\n}\n\n.today-sessions .sessions-list > li.paused .session-state,\n.today-sessions .sessions-list ul li.paused .session-state {\n    background-color: #ffc107 !important; /* Yellow background to match border */\n    color: #000 !important; /* Black text for better contrast on yellow */\n}\n\n.today-sessions .sessions-list > li.finalized .session-state,\n.today-sessions .sessions-list ul li.finalized .session-state {\n    background-color: #dc3545 !important; /* Red background to match border */\n    color: #fff !important; /* White text for contrast */\n}\n\n.session-start {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n\n.filter {\n    background: #fff;\n    border: none;\n    border-radius: 16px;\n    min-width: 130px;\n    padding: 5px 7px;\n    color: #404B52;\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    white-space: nowrap;\n    cursor: pointer;\n\n}\n\n.selected-filter {\n    background: var(--Primary-Color, #0877BC);\n    color: #FFF;\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n\n.sessions-list {\n    padding: 5px;\n    position: relative;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 15px;\n    list-style: none;\n    margin: 0;\n}\n\n/* Container for Today's Training Sessions - match metrics container structure exactly */\n.today-sessions {\n    margin: 2px 8px !important; /* Match .metrics margin exactly */\n    width: auto !important; /* Let browser calculate width based on margin */\n    max-width: 100% !important;\n    display: block !important;\n    padding: 0 !important;\n    box-sizing: border-box;\n    position: relative;\n}\n\n/* Today's Training Sessions list container - match metrics-container exactly */\n.today-sessions .sessions-list {\n    display: block !important; /* Override grid display from general .sessions-list */\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0 5px !important; /* Match .metrics-container padding exactly */\n    margin: 0 !important;\n    box-sizing: border-box;\n    position: relative !important;\n}\n\n/* Remove ul/li styling for today-sessions since we're using Slide component */\n.today-sessions .sessions-list ul {\n    display: none; /* Hide ul since we're using Slide component */\n}\n\n/* Make Today's Training Sessions cards match metric cards (slideData) styling with background image */\n.today-sessions .slideData.session-card {\n    display: flex !important;\n    align-items: stretch !important;\n    gap: 18px !important;\n    background: linear-gradient(135deg, #fff 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 7%, #fff) 100%) !important;\n    border-radius: 16px !important;\n    padding: 18px 18px 18px 164px !important;\n    box-shadow: 0 8px 22px color-mix(in srgb, var(--brand-primary, #0877BC) 20%, transparent) !important;\n    margin: 15px 10px !important;\n    background-color: #fff !important;\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 22%, #fff) !important;\n    transition: all 0.3s ease !important;\n    position: relative !important;\n    overflow: hidden !important;\n    cursor: pointer !important;\n    min-height: 188px !important;\n    height: 188px !important;\n    background-image: url(./assets/training_session_icon.png), linear-gradient(135deg, #fff 0%, #f8f9fa 100%) !important;\n    background-repeat: no-repeat, no-repeat !important;\n    background-position: left center, center !important;\n    background-size: 146px 100%, cover !important;\n}\n\n.today-sessions .slideData.session-card:hover {\n    transform: translateY(-3px) !important;\n    box-shadow: 0 12px 30px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent) !important;\n}\n\n.today-sessions .slideData.session-card::before {\n    content: '' !important;\n    position: absolute !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    height: 4px !important;\n    background: linear-gradient(90deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 72%, #000) 100%) !important;\n    z-index: 1 !important;\n}\n\n/* Ensure content styling matches metric cards */\n.today-sessions .slideData.session-card .session-info.card-info {\n    margin-left: 0 !important;\n    padding-left: 0 !important;\n    width: auto !important;\n    flex: 1 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    text-align: left !important;\n    overflow: hidden !important;\n    max-height: 100% !important;\n    justify-content: flex-start !important;\n}\n\n.today-session-group-tag {\n    position: absolute;\n    left: 8px;\n    bottom: 8px;\n    max-width: 136px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    border-radius: 8px;\n    padding: 6px 9px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #fff;\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 70%, #000);\n}\n\n.today-session-side {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 10px;\n    min-width: 92px;\n}\n\n.today-sessions .slideData.session-card .session-info h3 {\n    color: var(--Black, #202226) !important;\n    font-family: Poppins !important;\n    font-size: 15px !important;\n    font-weight: 600 !important;\n    margin: 0 0 8px 0 !important;\n}\n\n.today-sessions .slideData.session-card .session-info p {\n    color: #838383 !important;\n    font-family: Poppins !important;\n    font-size: 14px !important;\n    margin: 0 !important;\n}\n\n/* Ensure running/started sessions in Today's Training Sessions have green border */\n.today-sessions .slideData.session-card.running {\n    border: 2px solid #28a745 !important; /* Green border for running/started */\n}\n\n.today-sessions .slideData.session-card.active.running {\n    border: 3px solid #28a745 !important; /* Green border for running state when selected */\n}\n\n/* Support for nested ul structure (SessionsList component) */\n.sessions-list ul {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 15px;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sessions-list > li,\n.sessions-list ul li {\n    display: flex;\n    align-items: center;\n    border-radius: 8px;\n    padding: 15px;\n    justify-content: space-between;\n    background: #fff;\n    cursor: pointer;\n    min-height: 110px;\n    height: auto;\n    width: 100%;\n    box-shadow: 0px 0px 5px color-mix(in srgb, var(--brand-primary, #0877BC) 35%, transparent);\n    margin: 0;\n    list-style: none;\n}\n\n/* Home date-filtered sessions: centered layout with larger cards */\n/* Home date-filtered sessions: centered layout with larger cards */\n.home-date-sessions .sessions-list {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 12px 10px !important;\n}\n\n.home-date-sessions .sessions-list ul {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 14px !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    list-style: none !important;\n}\n\n.home-date-sessions .sessions-list > li,\n.home-date-sessions .sessions-list ul li {\n    min-height: auto !important;\n    padding: 16px !important;\n    gap: 16px !important;\n    position: relative !important;\n}\n\n.home-date-sessions .sessions-list .session-info {\n    width: auto !important;\n    flex: 1 !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n}\n\n.home-date-sessions .sessions-list .session-info h3 {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    line-height: 1.3 !important;\n    margin-bottom: 4px !important;\n    color: var(--text-color, #ffffff) !important;\n}\n\n.home-date-sessions .sessions-list .session-info p {\n    font-size: 12px !important;\n    line-height: 1.35 !important;\n}\n\n.home-date-sessions .session-start {\n    position: static !important;\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-end !important;\n    justify-content: center !important;\n    gap: 8px !important;\n    min-width: 90px !important;\n}\n\n.home-date-sessions .session-state {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 4px !important;\n    padding: 4px 10px !important;\n    border-radius: 20px !important;\n    font-size: 10px !important;\n    font-weight: 700 !important;\n    letter-spacing: 0.03em !important;\n    text-transform: uppercase !important;\n    border: 1px solid rgba(255, 255, 255, 0.1) !important;\n    box-shadow: none !important;\n}\n\n.home-date-sessions .session_edit {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    gap: 8px !important;\n}\n\n/* Branded home date-filtered session cards */\n@keyframes pulse {\n    0% { transform: scale(1); opacity: 0.9; }\n    50% { transform: scale(1.15); opacity: 1; filter: drop-shadow(0 0 6px rgba(255, 69, 58, 0.6)); }\n    100% { transform: scale(1); opacity: 0.9; }\n}\n\n.home-date-sessions .home-session-card {\n    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;\n    backdrop-filter: blur(20px) !important;\n    -webkit-backdrop-filter: blur(20px) !important;\n    border: 1px solid var(--glass-border, rgba(8, 119, 188, 0.15)) !important;\n    border-left: 4px solid var(--brand-secondary, #46528b) !important;\n    box-shadow: 0 4px 20px var(--shadow-color, rgba(0, 0, 0, 0.25)) !important;\n    border-radius: 14px !important;\n    padding: 14px 18px !important;\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    color: var(--text-color, #ffffff) !important;\n    cursor: pointer !important;\n    display: flex !important;\n    flex-direction: column !important; /* distributed on lines, not columns */\n    position: relative !important;\n    overflow: hidden !important;\n    align-items: stretch !important;\n    gap: 8px !important;\n}\n\n/* Hover state glow matched to branding and state */\n.home-date-sessions .home-session-card:hover {\n    transform: translateY(-2px) !important;\n    border-color: rgba(8, 119, 188, 0.35) !important;\n    box-shadow: 0 8px 24px rgba(8, 119, 188, 0.15), 0 2px 8px rgba(0, 0, 0, 0.3) !important;\n}\n\n.home-date-sessions .home-session-card.scheduled:hover {\n    border-color: rgba(8, 119, 188, 0.4) !important;\n    box-shadow: 0 8px 24px rgba(8, 119, 188, 0.12) !important;\n}\n\n.home-date-sessions .home-session-card.running:hover {\n    border-color: rgba(8, 119, 188, 0.5) !important;\n    box-shadow: 0 8px 24px rgba(8, 119, 188, 0.2) !important;\n}\n\n.home-date-sessions .home-session-card.paused:hover {\n    border-color: rgba(255, 159, 10, 0.45) !important;\n    box-shadow: 0 8px 24px rgba(255, 159, 10, 0.15) !important;\n}\n\n.home-date-sessions .home-session-card.finalized:hover {\n    border-color: rgba(220, 53, 69, 0.5) !important;\n    box-shadow: 0 8px 24px rgba(220, 53, 69, 0.18) !important;\n}\n\n.home-date-sessions .home-session-card:active {\n    transform: translateY(0) scale(0.99) !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;\n}\n\n.home-date-sessions .home-session-card__accent {\n    display: none !important;\n}\n\n.home-date-sessions .home-session-card__body {\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: center !important;\n    gap: 6px !important;\n    min-width: 0 !important;\n    flex: 1 !important;\n    text-align: left !important;\n}\n\n.home-date-sessions .home-session-card__title-row {\n    display: flex !important;\n    align-items: center !important;\n    gap: 12px !important;\n    flex-wrap: wrap !important;\n}\n\n.home-date-sessions .home-session-card__body h3 {\n    color: var(--text-color, #ffffff) !important;\n    font-size: 17px !important;\n    font-weight: 700 !important;\n    margin: 0 !important;\n    line-height: 1.25 !important;\n    letter-spacing: -0.3px !important;\n}\n\n.home-date-sessions .home-session-card__group {\n    margin: 0 !important;\n    font-size: 10px !important;\n    font-weight: 700 !important;\n    color: var(--brand-secondary, #30D5C8) !important;\n    background: rgba(48, 213, 200, 0.1) !important;\n    border: 1px solid rgba(48, 213, 200, 0.22) !important;\n    padding: 2px 8px !important;\n    border-radius: 20px !important;\n    text-transform: uppercase !important;\n    letter-spacing: 0.04em !important;\n}\n\n.home-date-sessions .home-session-card__datetime {\n    margin: 0 !important;\n    font-size: 12px !important;\n    font-weight: 500 !important;\n    color: var(--text-secondary, rgba(255, 255, 255, 0.5)) !important;\n}\n\n.home-date-sessions .home-session-card__hint {\n    margin: 4px 0 0 !important;\n    font-size: 11px !important;\n    font-weight: 500 !important;\n    line-height: 1.35 !important;\n    color: var(--text-secondary, rgba(255, 255, 255, 0.4)) !important;\n    font-style: italic !important;\n}\n\n.home-date-sessions .home-session-card__meta {\n    display: flex !important;\n    align-items: center !important;\n    gap: 6px !important;\n    margin-top: 4px !important;\n    font-size: 11px !important;\n    font-weight: 600 !important;\n    color: var(--text-secondary, rgba(255, 255, 255, 0.5)) !important;\n    flex-wrap: wrap !important;\n}\n\n.home-date-sessions .home-session-card__meta-separator {\n    color: var(--border-color, rgba(255, 255, 255, 0.25)) !important;\n    font-size: 10px !important;\n}\n\n.home-date-sessions .home-session-card__difficulty {\n    padding: 2px 8px !important;\n    border-radius: 6px !important;\n    font-size: 10px !important;\n    text-transform: uppercase !important;\n    letter-spacing: 0.05em !important;\n    font-weight: 700 !important;\n}\n\n.home-date-sessions .home-session-card__difficulty--easy {\n    background: rgba(50, 215, 75, 0.15) !important;\n    color: #32D74B !important;\n    border: 1px solid rgba(50, 215, 75, 0.25) !important;\n}\n\n.home-date-sessions .home-session-card__difficulty--medium {\n    background: rgba(255, 159, 10, 0.15) !important;\n    color: #FF9F0A !important;\n    border: 1px solid rgba(255, 159, 10, 0.25) !important;\n}\n\n.home-date-sessions .home-session-card__difficulty--hard,\n.home-date-sessions .home-session-card__difficulty--intense {\n    background: rgba(255, 69, 58, 0.15) !important;\n    color: #FF453A !important;\n    border: 1px solid rgba(255, 69, 58, 0.25) !important;\n}\n\n.home-date-sessions .home-session-card__difficulty--pro,\n.home-date-sessions .home-session-card__difficulty--extreme {\n    background: rgba(191, 90, 242, 0.15) !important;\n    color: #BF5AF2 !important;\n    border: 1px solid rgba(191, 90, 242, 0.25) !important;\n}\n\n.home-date-sessions .home-session-card__aside {\n    display: flex !important;\n    flex-direction: row !important; /* side by side */\n    align-items: center !important;\n    justify-content: space-between !important; /* state badge on left, button/actions on right */\n    gap: 8px !important;\n    width: 100% !important;\n    min-width: unset !important;\n    margin-top: 6px !important;\n    padding-top: 8px !important;\n    border-top: 1px solid rgba(255, 255, 255, 0.06) !important;\n}\n\n.home-date-sessions .home-session-card__badge {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 4px !important;\n    padding: 4px 10px !important;\n    border-radius: 20px !important;\n    font-size: 10px !important;\n    font-weight: 700 !important;\n    letter-spacing: 0.03em !important;\n    text-transform: uppercase !important;\n    border: 1px solid rgba(255, 255, 255, 0.1) !important;\n    box-shadow: none !important;\n}\n\n.home-date-sessions .home-session-card__badge--scheduled {\n    background: rgba(191, 90, 242, 0.15) !important;\n    color: #BF5AF2 !important;\n    border: 1px solid rgba(191, 90, 242, 0.25) !important;\n}\n\n.home-date-sessions .home-session-card__badge--running {\n    background: rgba(10, 132, 255, 0.15) !important;\n    color: #0A84FF !important;\n    border: 1px solid rgba(10, 132, 255, 0.3) !important;\n}\n\n.home-date-sessions .home-session-card__badge--paused {\n    background: rgba(255, 159, 10, 0.15) !important;\n    color: #FF9F0A !important;\n    border: 1px solid rgba(255, 159, 10, 0.25) !important;\n}\n\n.home-date-sessions .home-session-card__badge--finalized {\n    background: rgba(220, 53, 69, 0.12) !important;\n    color: #dc3545 !important;\n    border: 1px solid rgba(220, 53, 69, 0.28) !important;\n}\n\n.home-date-sessions .home-session-card__live-dot {\n    width: 6px !important;\n    height: 6px !important;\n    background: #0A84FF !important;\n    box-shadow: 0 0 8px #0A84FF !important;\n    border-radius: 50% !important;\n}\n\n/* Started sessions: stronger brand presence */\n.home-date-sessions .home-session-card--started {\n    border-width: 1px !important;\n}\n\n.home-date-sessions .home-session-card.running {\n    border-color: rgba(8, 119, 188, 0.45) !important;\n    border-left: 4px solid var(--brand-primary, #0877BC) !important;\n    box-shadow: 0 6px 20px rgba(8, 119, 188, 0.2) !important;\n}\n\n.home-date-sessions .home-session-card.running::before {\n    display: none !important;\n}\n\n.home-date-sessions .home-session-card.paused {\n    border-color: rgba(255, 159, 10, 0.35) !important;\n    border-left: 4px solid #FF9F0A !important;\n    box-shadow: 0 6px 20px rgba(255, 159, 10, 0.15) !important;\n}\n\n.home-date-sessions .home-session-card.paused::before {\n    display: none !important;\n}\n\n.home-date-sessions .home-session-card.finalized {\n    border-color: rgba(220, 53, 69, 0.4) !important;\n    border-left: 4px solid #dc3545 !important;\n    box-shadow: 0 6px 20px rgba(220, 53, 69, 0.15) !important;\n}\n\n.home-date-sessions .home-session-card.finalized::before {\n    display: none !important;\n}\n\n.home-date-sessions .home-session-card.active {\n    border-color: var(--brand-primary, #0877BC) !important;\n}\n\n.home-date-sessions .home-session-card .session_edit svg {\n    color: var(--brand-primary, #0A84FF) !important;\n}\n\n.home-date-sessions .home-session-card.running .session_edit svg {\n    color: var(--brand-primary, #0A84FF) !important;\n}\n\n/* Drills blueprint tags preview list styling */\n.home-date-sessions .home-session-card__drills {\n    margin-top: 6px !important;\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 6px !important;\n}\n\n.home-date-sessions .home-session-card__drills-list {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    gap: 6px !important;\n}\n\n.home-date-sessions .home-session-card__drill-tag {\n    display: inline-flex !important;\n    align-items: center !important;\n    gap: 6px !important;\n    background: color-mix(in srgb, var(--text-color, #ffffff) 6%, transparent) !important;\n    border: 1px solid color-mix(in srgb, var(--text-color, #ffffff) 12%, transparent) !important;\n    border-radius: 8px !important;\n    padding: 3px 8px !important;\n    font-size: 11px !important;\n    font-weight: 500 !important;\n    color: color-mix(in srgb, var(--text-color, #ffffff) 80%, transparent) !important;\n    line-height: 1.25 !important;\n    transition: all 0.2s ease !important;\n}\n\n.home-date-sessions .home-session-card__drill-tag:hover {\n    background: color-mix(in srgb, var(--text-color, #ffffff) 12%, transparent) !important;\n    color: var(--text-color, #ffffff) !important;\n    border-color: color-mix(in srgb, var(--text-color, #ffffff) 25%, transparent) !important;\n}\n\n.home-date-sessions .home-session-card__drill-dot {\n    width: 5px !important;\n    height: 5px !important;\n    background: color-mix(in srgb, var(--text-color, #ffffff) 35%, transparent) !important;\n    border-radius: 50% !important;\n}\n\n.home-date-sessions .home-session-card.running .home-session-card__drill-dot {\n    background: #0A84FF !important;\n    box-shadow: 0 0 5px #0A84FF !important;\n}\n\n.home-date-sessions .home-session-card.paused .home-session-card__drill-dot {\n    background: #FF9F0A !important;\n    box-shadow: 0 0 5px #FF9F0A !important;\n}\n\n.home-date-sessions .home-session-card.finalized .home-session-card__drill-dot {\n    background: #dc3545 !important;\n    box-shadow: 0 0 5px #dc3545 !important;\n}\n\n.home-date-sessions .home-session-card__drill-tag--more {\n    background: color-mix(in srgb, var(--text-color, #ffffff) 10%, transparent) !important;\n    color: color-mix(in srgb, var(--text-color, #ffffff) 60%, transparent) !important;\n    font-weight: 600 !important;\n}\n\n/* Session card HR summary — same tiles as exercise result cards */\n.home-date-sessions .home-session-card__hr-summary {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    margin-top: 4px !important;\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n}\n\n.home-date-sessions .home-session-card__hr-summary-card {\n    margin-bottom: 0 !important;\n    padding: 10px 6px !important;\n    box-shadow: none !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    box-sizing: border-box !important;\n    gap: 6px !important;\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n}\n\n.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard {\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n    padding: 8px 4px !important;\n    box-sizing: border-box !important;\n    overflow: hidden !important;\n}\n\n.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard-header {\n    width: 100% !important;\n    justify-content: center !important;\n    text-align: center !important;\n    flex-wrap: wrap !important;\n    font-size: 9px !important;\n    line-height: 1.15 !important;\n    gap: 3px !important;\n}\n\n.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard-header span {\n    white-space: normal !important;\n    text-align: center !important;\n    word-break: break-word !important;\n}\n\n.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard-value {\n    font-size: 17px !important;\n    max-width: 100% !important;\n    text-align: center !important;\n}\n\n.home-date-sessions .home-session-card__hr-summary-card .player-exercise-details__hr-subcard-unit {\n    font-size: 10px !important;\n}\n\n.home-date-sessions .home-session-card__hr-player-name {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-top: 2px;\n    padding: 0 2px;\n    font-size: 10px;\n    font-weight: 500;\n    color: var(--brand-text-secondary, #6b7280);\n    line-height: 1.2;\n    white-space: normal !important;\n    word-break: break-word;\n    text-align: center;\n    width: 100%;\n    max-width: 100%;\n    min-height: 2.4em;\n    box-sizing: border-box;\n}\n\n/* Premium Heart Rate Widget design (legacy — replaced by hr-summary tiles) */\n.home-date-sessions .home-session-card__hr-container {\n    display: flex !important;\n    align-items: center !important;\n    gap: 12px !important;\n    padding: 8px 14px !important;\n    border-radius: 12px !important;\n    background: rgba(255, 69, 58, 0.05) !important;\n    border: 1px solid rgba(255, 69, 58, 0.15) !important;\n    margin-right: 6px !important;\n    align-self: center !important;\n    box-shadow: inset 0 0 10px rgba(255, 69, 58, 0.02) !important;\n    transition: transform 0.2s ease, border-color 0.2s ease !important;\n}\n\n.home-date-sessions .home-session-card__hr-container:hover {\n    border-color: rgba(255, 69, 58, 0.3) !important;\n    transform: scale(1.02) !important;\n}\n\n.home-date-sessions .home-session-card__hr-icon {\n    font-size: 20px !important;\n    color: #FF453A !important;\n    animation: pulse 1.8s infinite ease-in-out !important;\n}\n\n.home-date-sessions .home-session-card__hr-stats {\n    display: flex !important;\n    align-items: center !important;\n    gap: 10px !important;\n}\n\n.home-date-sessions .home-session-card__hr-stat {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n}\n\n.home-date-sessions .home-session-card__hr-label {\n    font-size: 8px !important;\n    font-weight: 700 !important;\n    text-transform: uppercase !important;\n    color: var(--text-secondary, rgba(255, 255, 255, 0.4)) !important;\n    letter-spacing: 0.06em !important;\n    line-height: 1 !important;\n    margin-bottom: 2px !important;\n}\n\n.home-date-sessions .home-session-card__hr-value {\n    font-size: 13px !important;\n    font-weight: 700 !important;\n    color: var(--text-color, #ffffff) !important;\n    font-family: SF Pro Text, -apple-system, monospace !important;\n    line-height: 1.15 !important;\n}\n\n.home-date-sessions .home-session-card__hr-divider {\n    width: 1px !important;\n    height: 20px !important;\n    background: var(--border-color, rgba(255, 255, 255, 0.1)) !important;\n}\n\n/* Override generic session-list state colors inside home date filter */\n.home-date-sessions .sessions-list ul li.home-session-card {\n    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;\n    border: 1px solid var(--glass-border, rgba(8, 119, 188, 0.15)) !important;\n    color: var(--text-color, #ffffff) !important;\n    box-shadow: 0 4px 20px var(--shadow-color, rgba(0, 0, 0, 0.25)) !important;\n}\n\n.home-date-sessions .sessions-list ul li.home-session-card.scheduled {\n    border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08)) !important;\n    background: var(--glass-bg, rgba(20, 20, 22, 0.65)) !important;\n}\n\n.home-date-sessions .sessions-list ul li.home-session-card.scheduled::before {\n    content: \"\" !important;\n    position: absolute !important;\n    left: 0 !important;\n    top: 0 !important;\n    bottom: 0 !important;\n    width: 4px !important;\n    background: #BF5AF2 !important;\n}\n\n.home-date-sessions .sessions-list ul li.home-session-card.running {\n    border-color: rgba(10, 132, 255, 0.4) !important;\n    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;\n}\n\n.home-date-sessions .sessions-list ul li.home-session-card.paused {\n    border-color: rgba(255, 159, 10, 0.35) !important;\n    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;\n}\n\n.home-date-sessions .sessions-list ul li.home-session-card.finalized {\n    border-color: rgba(220, 53, 69, 0.4) !important;\n    background: var(--glass-bg, rgba(18, 22, 33, 0.75)) !important;\n}\n\n.home-date-sessions .sessions-list ul li.home-session-card.active,\n.home-date-sessions .sessions-list ul li.home-session-card.home-session-card--selected,\n.home-date-sessions .sessions-list ul li.home-session-card.active.running,\n.home-date-sessions .sessions-list ul li.home-session-card.active.paused,\n.home-date-sessions .sessions-list ul li.home-session-card.active.finalized,\n.home-date-sessions .sessions-list ul li.home-session-card.active.scheduled {\n    border: 2px solid var(--brand-primary, #0A84FF) !important;\n    background: color-mix(\n        in srgb,\n        var(--brand-primary, #0A84FF) 18%,\n        var(--glass-bg, rgba(18, 22, 33, 0.75))\n    ) !important;\n    box-shadow:\n        0 0 0 3px color-mix(in srgb, var(--brand-primary, #0A84FF) 40%, transparent),\n        0 10px 28px color-mix(in srgb, var(--brand-primary, #0A84FF) 28%, transparent) !important;\n}\n\n.home-date-sessions .sessions-list ul li.home-session-card.active .session-info h3 {\n    color: var(--text-color, #ffffff) !important;\n}\n\n.home-date-sessions .sessions-list ul li.home-session-card.active::before {\n    display: none !important;\n}\n\n.sessions-list > li.active,\n.sessions-list ul li.active {\n    border: 3px solid var(--brand-primary, #0877BC);\n    box-shadow: 0px 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 45%, transparent);\n    transform: translateY(-2px);\n    transition: all 0.3s ease;\n    background-color: #fff; /* White background */\n    position: relative;\n}\n\n/* Session State Colors - White background with colored borders based on state */\n.sessions-list > li.scheduled,\n.sessions-list ul li.scheduled {\n    background-color: #fff !important; /* White background */\n    border: 2px solid #6c757d; /* Gray border for scheduled */\n}\n\n.sessions-list > li.running,\n.sessions-list ul li.running {\n    background-color: #fff !important; /* White background */\n    border: 2px solid #28a745 !important; /* Green border for running/started */\n}\n\n.sessions-list > li.paused,\n.sessions-list ul li.paused {\n    background-color: #fff; /* White background */\n    border: 2px solid #ffc107; /* Yellow border for paused */\n}\n\n.sessions-list > li.finalized,\n.sessions-list ul li.finalized {\n    background-color: #fff; /* White background */\n    border: 2px solid #dc3545; /* Red border for finalized */\n}\n\n/* Combined states: active + state - Only selected cards change border color based on state */\n.sessions-list > li.active.scheduled,\n.sessions-list ul li.active.scheduled {\n    border: 3px solid #6c757d; /* Gray border for scheduled state when selected */\n    background-color: #fff !important; /* White background */\n}\n\n.sessions-list > li.active.running,\n.sessions-list ul li.active.running {\n    border: 3px solid #28a745 !important; /* Green border for running state when selected */\n    background-color: #fff !important; /* White background */\n}\n\n.sessions-list > li.active.paused,\n.sessions-list ul li.active.paused {\n    border: 3px solid #ffc107; /* Yellow border for paused state when selected */\n    background-color: #fff; /* White background */\n}\n\n.sessions-list > li.active.finalized,\n.sessions-list ul li.active.finalized {\n    border: 3px solid #dc3545; /* Red border for finalized state when selected */\n    background-color: #fff; /* White background */\n}\n\n/* Homepage calendar list: the chosen session stays branded, in every state. */\n.home-theme-root .home-date-sessions .sessions-list ul li.home-session-card.home-session-card--selected,\n.home-theme-root .sessions-list ul li.home-session-card.home-session-card--selected {\n    border: 2px solid var(--brand-primary, #0A84FF) !important;\n    background: color-mix(\n        in srgb,\n        var(--brand-primary, #0A84FF) 18%,\n        var(--surface-color, #121621)\n    ) !important;\n    box-shadow:\n        0 0 0 3px color-mix(in srgb, var(--brand-primary, #0A84FF) 40%, transparent),\n        0 10px 28px color-mix(in srgb, var(--brand-primary, #0A84FF) 28%, transparent) !important;\n}\n\n/* Ensure text is readable in finalized cards */\n.sessions-list > li.finalized .session-info h3,\n.sessions-list > li.finalized .session-info p,\n.sessions-list > li.active.finalized .session-info h3,\n.sessions-list > li.active.finalized .session-info p {\n    color: #333 !important;\n    opacity: 1 !important;\n}\n\n.sessions-list > li.active::before,\n.sessions-list ul li.active::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    background: var(--brand-primary, #0877BC);\n    border-radius: 8px 0 0 8px;\n}\n\n.sessions-list > li.active .session_imgbox,\n.sessions-list ul li.active .session_imgbox {\n    border-color: var(--brand-primary, #0877BC);\n    background-color: color-mix(in srgb, var(--brand-primary, #0877BC) 12%, #fff);\n}\n\n.sessions-list > li.active .session-info h3,\n.sessions-list ul li.active .session-info h3 {\n    color: var(--brand-primary, #0877BC);\n    font-weight: 700;\n}\n\n/* Ensure text is readable in active finalized cards */\n.sessions-list > li.active.finalized .session-info h3 {\n    color: var(--brand-primary, #0877BC) !important;\n    font-weight: 700;\n}\n\n.sessions-list > li.active.finalized .session-info p {\n    color: #333 !important;\n    opacity: 1 !important;\n}\n\n/* Removed duplicate finalized styles - using the new finalized styles above */\n\n.sessions-list > li.onprogress,\n.sessions-list ul li.onprogress {\n    background: #a62d32;\n    color: #fff;\n}\n\n.onprogress .session-state {\n    background-color: #fff;\n    color: #a62d32\n}\n\n.onprogress .session-info p {\n    color: #ffffffd5 !important;\n}\n\n/* .sessions-list ul li.active h3,\n.sessions-list ul li.active p {\n    color: #ffffff;\n} */\n\n.session-image-add {\n    width: 16%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--brand-primary, #0877BC);\n    border-radius: 8px;\n    padding: 10px;\n\n}\n\n.session-image-add2 {\n    width: 16%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n    padding: 5px;\n    border: 2px solid var(--brand-primary, #0877BC);\n    background-color: var(--brand-primary, #0877BC);\n}\n\n.session-image-add img,\n.session-image-add2 img {\n    height: 100%;\n    width: auto;\n    object-fit: contain; /* Preserve aspect ratio */\n    max-width: 100%;\n}\n\n.session-image-add2 svg {\n    width: 30px;\n    height: 30px;\n    color: #fff;\n}\n\n\n.sessions-list .session-image {\n    width: 20%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #fff;\n    border-radius: 8px;\n\n\n}\n\n.select_msg {\n    font-size: 14px;\n    text-align: center;\n    margin: 20px;\n    font-weight: bold;\n    color: #0877BC;\n}\n\n.session-image {\n    border: 1px solid #0877BC;\n    border-radius: 8px;\n\n}\n\n.session-image-select {\n    border: 1px solid #0877BC;\n    padding: 10px;\n}\n\n.session-image-select>img {\n    width: 30px;\n}\n\n.session-addinfo {\n    font-size: 13px;\n    padding-right: 80px;\n}\n\n.session_imgbox {\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--brand-primary, #0877BC);\n    border-radius: 8px;\n    padding: 3px 20px;\n    background-color: #fff;\n    object-fit: contain; /* Preserve aspect ratio */\n    max-width: 100%;\n    max-height: 100%;\n    width: 60px; /* Fixed width for consistent sizing */\n    min-width: 60px; /* Ensure minimum width */\n}\n\n.session_imgbox img {\n    width: 50px; /* Fixed width for the icon */\n    height: 50px; /* Fixed height for the icon */\n    object-fit: contain; /* Preserve aspect ratio */\n}\n\n.sessions-list .session-info {\n    width: 45%;\n}\n\n.sessions-list .session-info h3 {\n    font-size: 16px !important;\n}\n\n.sessions-list .session-info p {\n    font-size: 12px !important;\n    color: #7c7a7a;\n    font-weight: 600;\n}\n\n.sessions-list .session-start img {\n    width: 30px;\n    margin-right: 5px;\n}\n\n.select_sessions_info {\n    background-color: #fff;\n    min-width: 300px;\n    max-width: max-content;\n    box-shadow: 0 0 5px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent);\n    display: flex;\n    padding: 10px;\n    align-items: center;\n    gap: 20px;\n    position: relative;\n\n}\n\n.selectedsession_imgbox {\n    width: 70px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--brand-primary, #0877BC);\n    border-radius: 8px;\n    padding: 3px 13px;\n    background: #fff\n}\n\n/* Add Training Session Card - standalone card for calendar section */\n.session_add_box_add_card {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    border-radius: 8px;\n    margin: 0;\n    padding: 15px 20px;\n    background: var(--brand-primary, #0877BC);\n    cursor: pointer;\n    height: 75px;\n    box-shadow: 0 0 5px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent);\n    width: 100%;\n    max-width: 100%;\n    transition: all 0.3s ease;\n}\n\n.session_add_box_add_card:hover {\n    background: var(--brand-primary-dark, #065a94);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 50%, transparent);\n    transform: translateY(-2px);\n}\n\n.session-image-add-square {\n    width: 50px;\n    height: 50px;\n    min-width: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.2);\n    border-radius: 8px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n/* Calendar date-selector section */\n.calendar-and-add-section {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin: 12px auto 16px;\n    max-width: 1200px;\n    padding: 0 10px;\n    box-sizing: border-box;\n}\n\n.calendar-and-add-section .home-date-sessions-with-calendar {\n    width: 100%;\n    animation: dateRangePanelIn 0.22s ease both;\n}\n\n.calendar-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    max-width: 420px;\n}\n\n.calendar-wrapper .date_info {\n    width: 100%;\n}\n\n.add-session-wrapper {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin-top: 10px;\n}\n\n@media(max-width:1150px) {\n    /* Today's Training Sessions - keep one per line on mobile too */\n    .today-sessions .sessions-list {\n        grid-template-columns: 1fr;\n    }\n    .sessions-list ul {\n        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    }\n    \n    /* Today's Training Sessions - keep one per line on mobile too */\n    .today-sessions .sessions-list ul {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* On mobile: stack \"select a date\" message above the calendar so calendar is fully visible */\n@media (max-width: 768px) {\n    .calendar-and-add-section {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    .calendar-and-add-section .calendar-wrapper {\n        width: 100%;\n    }\n}\n\n@media(max-width:750px) {\n    .session_imgbox {\n        padding: 10px 6px;\n        width: 50px;\n        height: auto;\n    }\n\n    .sessions-list .session-info h3 {\n        font-size: 15px !important;\n\n    }\n\n    .sessions-list ul li {\n        padding: 10px 5px;\n        width: calc(100% - 10px);\n        margin: 10px 5px\n    }\n\n    .home-date-sessions .sessions-list ul {\n        grid-template-columns: 1fr;\n    }\n\n    .home-date-sessions .sessions-list > li,\n    .home-date-sessions .sessions-list ul li {\n        min-height: 118px;\n        padding: 14px 56px 14px 12px;\n    }\n    \n    /* Override for Today's Training Sessions to maintain full width */\n    .today-sessions .sessions-list ul li {\n        width: 100% !important;\n        margin: 0 !important;\n        padding: 18px 18px 18px 160px !important;\n    }\n\n    .sessions-list ul {\n        gap: 0px;\n    }\n\n\n\n}\n\n@media(max-width:650px) {\n    .filter {\n        min-width: 50px;\n        font-size: 11px;\n    }\n\n    .training-options-filter {\n        gap: 10px;\n    }\n\n    .session-image-add {\n        width: 90px\n    }\n\n    .session-addinfo {\n        padding-right: 10px;\n    }\n\n    .sessions-list ul {\n        grid-template-columns: auto;\n    }\n    \n    /* Today's Training Sessions - keep one per line on small screens */\n    .today-sessions .sessions-list ul {\n        grid-template-columns: 1fr;\n    }\n\n    /* Add Session Card responsive */\n    .calendar-wrapper {\n        max-width: 100%;\n        padding: 0 10px;\n    }\n\n    .session_add_box_add_card {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n/* Seasonal \"add sessions\" modal — brand-aware (uses CSS vars from BrandContext) */\n.seasonal-session-modal .seasonal-session-title {\n    font-size: 17px;\n    color: var(--brand-primary, #0877BC);\n    text-align: left;\n    margin: 0 0 8px;\n    font-weight: 600;\n}\n\n.seasonal-session-modal button.seasonal-session-submit {\n    width: 100%;\n    padding: 12px 16px;\n    margin-top: 8px;\n    background: var(--brand-primary, #0877BC);\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: 600;\n    transition: background 0.2s ease;\n}\n\n.seasonal-session-modal button.seasonal-session-submit:hover {\n    background: var(--brand-primary-dark, #065a94);\n}\n\n/* Add / seasonal / duplicate session dialogs — light + dark mode */\n.session-add-dialog {\n    color: var(--text-color);\n    background: var(--surface-color);\n    color-scheme: light;\n}\n\nhtml[data-theme=\"dark\"] .session-add-dialog,\nhtml.dark-mode .session-add-dialog,\n.dark-mode .session-add-dialog {\n    color-scheme: dark;\n}\n\n.session-add-dialog__field {\n    margin-top: 16px;\n    text-align: left;\n}\n\n.session-add-dialog__field > label,\n.session-add-dialog .input-detail > label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    font-size: 0.875rem;\n    color: var(--text-color) !important;\n}\n\n.session-add-dialog__input,\n.session-add-dialog .input-detail input[type=\"time\"],\n.session-add-dialog .input-detail input[type=\"number\"] {\n    width: 100%;\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid var(--border-color);\n    background: var(--surface-color);\n    color: var(--text-color);\n    color-scheme: light;\n    box-sizing: border-box;\n}\n\nhtml[data-theme=\"dark\"] .session-add-dialog__input,\nhtml.dark-mode .session-add-dialog__input,\n.dark-mode .session-add-dialog__input,\nhtml[data-theme=\"dark\"] .session-add-dialog .input-detail input[type=\"time\"],\nhtml.dark-mode .session-add-dialog .input-detail input[type=\"time\"],\n.dark-mode .session-add-dialog .input-detail input[type=\"time\"],\nhtml[data-theme=\"dark\"] .session-add-dialog .input-detail input[type=\"number\"],\nhtml.dark-mode .session-add-dialog .input-detail input[type=\"number\"],\n.dark-mode .session-add-dialog .input-detail input[type=\"number\"] {\n    color-scheme: dark;\n}\n\n.session-add-dialog input[type=\"time\"]::-webkit-calendar-picker-indicator {\n    cursor: pointer;\n    opacity: 1;\n    filter: none;\n}\n\nhtml[data-theme=\"dark\"] .session-add-dialog input[type=\"time\"]::-webkit-calendar-picker-indicator,\nhtml.dark-mode .session-add-dialog input[type=\"time\"]::-webkit-calendar-picker-indicator,\n.dark-mode .session-add-dialog input[type=\"time\"]::-webkit-calendar-picker-indicator {\n    filter: invert(1);\n}\n\n.session-add-dialog__duration {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.session-add-dialog__duration label {\n    margin: 0 !important;\n    color: var(--text-secondary) !important;\n    font-weight: 500 !important;\n}\n\n.session-add-dialog__calendar {\n    background: var(--surface-color);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.session-add-dialog__calendar .rdrCalendarWrapper,\n.session-add-dialog__calendar .rdrDateDisplayWrapper,\n.session-add-dialog__calendar .rdrMonth {\n    background: var(--surface-color) !important;\n    color: var(--text-color) !important;\n}\n\n.session-add-dialog__calendar .rdrMonthAndYearPickers select,\n.session-add-dialog__calendar .rdrWeekDay,\n.session-add-dialog__calendar .rdrDayNumber span {\n    color: var(--text-color) !important;\n}\n\n.session-add-dialog__calendar .rdrDayPassive .rdrDayNumber span {\n    color: var(--text-secondary) !important;\n    opacity: 0.55;\n}\n\n.session-add-dialog__calendar .rdrDayDisabled {\n    background-color: transparent !important;\n}\n\n.session-add-dialog__calendar .rdrDayToday .rdrDayNumber span:after {\n    background: var(--brand-primary, #0877BC) !important;\n}\n\n.session-add-dialog__calendar .rdrSelected,\n.session-add-dialog__calendar .rdrDayStartPreview,\n.session-add-dialog__calendar .rdrDayEndPreview,\n.session-add-dialog__calendar .rdrDayInPreview {\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 22%, transparent) !important;\n}\n\n.session-add-dialog__calendar .rdrDayHovered .rdrDayNumber span,\n.session-add-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrDayNumber span {\n    color: var(--text-color) !important;\n}\n\n.session-add-dialog__calendar .rdrNextPrevButton {\n    background: color-mix(in srgb, var(--text-color) 8%, var(--surface-color)) !important;\n}\n\n.session-add-dialog__calendar .rdrNextPrevButton i {\n    border-color: var(--text-color) !important;\n}\n\n.session-add-dialog__calendar .rdrPprevButton i {\n    border-color: var(--text-color) !important;\n}\n\n.dark-mode .session-add-dialog__calendar .rdrDayNumber span,\nhtml.dark-mode .session-add-dialog__calendar .rdrDayNumber span {\n    color: var(--text-color) !important;\n}\n\n.dark-mode .session-add-dialog__calendar .rdrWeekDay,\nhtml.dark-mode .session-add-dialog__calendar .rdrWeekDay {\n    color: var(--text-secondary) !important;\n}\n\n.session-readonly-banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    max-width: 1100px;\n    margin: 0 auto 14px;\n    padding: 10px 14px;\n    border-radius: 8px;\n    background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);\n    color: var(--text-color);\n    font-size: 13px;\n}\n\n.session-readonly-banner__icon {\n    color: var(--brand-primary, #0877bc);\n    font-size: 22px !important;\n    margin-top: 1px;\n    flex-shrink: 0;\n}\n\n.session-readonly-banner__text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    color: var(--text-secondary);\n}\n\n.session-readonly-banner__text strong {\n    color: var(--brand-primary, #0877bc);\n    font-weight: 700;\n}\n\n/* Custom premium additions for date-filtered sessions */\n.home-sessions-loading-state {\n    padding: 24px 20px !important;\n    text-align: center !important;\n    color: rgba(255, 255, 255, 0.6) !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    background: rgba(18, 19, 23, 0.4) !important;\n    border-radius: 16px !important;\n    border: 1px solid rgba(255, 255, 255, 0.05) !important;\n    backdrop-filter: blur(12px) !important;\n    -webkit-backdrop-filter: blur(12px) !important;\n    margin-bottom: 12px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 10px !important;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.home-sessions-loading-spinner {\n    width: 16px !important;\n    height: 16px !important;\n    border: 2px solid rgba(255, 255, 255, 0.15) !important;\n    border-top: 2px solid var(--brand-primary, #0A84FF) !important;\n    border-radius: 50% !important;\n    animation: spin 0.8s linear infinite !important;\n    display: inline-block !important;\n}\n\n.home-sessions-empty-state {\n    padding: 28px 20px !important;\n    text-align: center !important;\n    color: rgba(255, 255, 255, 0.45) !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    margin-bottom: 12px !important;\n    background: rgba(18, 19, 23, 0.4) !important;\n    border: 1px dashed rgba(255, 255, 255, 0.1) !important;\n    border-radius: 16px !important;\n    backdrop-filter: blur(12px) !important;\n    -webkit-backdrop-filter: blur(12px) !important;\n}\n\n/* Premium action buttons inside the date-filtered session cards */\n.home-date-sessions .deactive_btn {\n    background: linear-gradient(135deg, var(--brand-primary, #0A84FF) 0%, #0056b3 100%) !important;\n    border: 1px solid rgba(10, 132, 255, 0.25) !important;\n    color: #ffffff !important;\n    font-weight: 700 !important;\n    border-radius: 10px !important;\n    padding: 6px 14px !important;\n    font-size: 11px !important;\n    text-transform: uppercase !important;\n    letter-spacing: 0.05em !important;\n    cursor: pointer !important;\n    box-shadow: 0 4px 12px rgba(10, 132, 255, 0.2) !important;\n    transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s ease, filter 0.2s ease !important;\n    margin: 0 !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    line-height: 1.2 !important;\n}\n\n.home-date-sessions .deactive_btn:hover {\n    transform: translateY(-2px) !important;\n    box-shadow: 0 6px 16px rgba(10, 132, 255, 0.35) !important;\n    filter: brightness(1.1) !important;\n}\n\n.home-date-sessions .deactive_btn:active {\n    transform: translateY(0) !important;\n}\n\n/* Glassmorphic icon buttons inside the session cards */\n.home-date-sessions .session_edit p {\n    margin: 0 !important;\n    width: 32px !important;\n    height: 32px !important;\n    border-radius: 10px !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    background: rgba(255, 255, 255, 0.04) !important;\n    border: 1px solid rgba(255, 255, 255, 0.08) !important;\n    color: rgba(255, 255, 255, 0.75) !important;\n    cursor: pointer !important;\n    transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.2s ease, border-color 0.2s ease, color 0.2s ease !important;\n}\n\n.home-date-sessions .session_edit p:hover {\n    transform: translateY(-2px) !important;\n    background: rgba(255, 255, 255, 0.08) !important;\n    color: #ffffff !important;\n    border-color: rgba(255, 255, 255, 0.18) !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n}\n\n.home-date-sessions .session_edit p:active {\n    transform: translateY(0) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
